export default __webpack_public_path__ + "locales/az/Settings.json?hash=d9bb04074f9f200e444549d3c672fc0c";